import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { createWorkflowTarefaAnexoOnUpdate, createWorkflowTarefaAnexo, workflowSelector } from "../../../store/workflow";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import InputAnexo from "../../../components/input-anexo";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import { fetchVerificarLimite } from "../../../store/empresa";

export default function WorkflowTarefaAnexoCriar(props) {
  const { tarefaId, workflowId: workflowIdFromProps } = props;
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const workflow = useSelector(workflowSelector);

  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const [isUploading, setIsUploading] = useState(false);

  const currentWorkflowId = workflow?.id ?? workflowIdFromProps;

  const handleChange = (anexo) => {

    unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
    .then(() => {
       setIsUploading(true);

    const actionCreator = props.onUpdate ? createWorkflowTarefaAnexoOnUpdate : createWorkflowTarefaAnexo;
    const action = actionCreator({ workflowId: currentWorkflowId, tarefaId, anexo });

    unwrapAxiosPromise(dispatch(action))
      .then(() => {
        if (props.onUpdate) {
          props.onUpdate();
        }
      })
      .catch((error) => {
        console.error("Failed to upload attachment:", error);
      })
      .finally(() => {
        if (isMounted.current) {
          setIsUploading(false);
        }
      });
            
    })
  };

  return (
    <div>
      <InputAnexo compact disabled={isUploading} onChange={handleChange} />
    </div>
  );
}

WorkflowTarefaAnexoCriar.propTypes = {
  tarefaId: PropTypes.number.isRequired,
  workflowId: PropTypes.number,
  onUpdate: PropTypes.func,
};
